// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-tel-input[data-v-2a67d988]{direction:ltr!important;border:1px solid rgba(0,0,0,.6)!important;border-radius:4px!important}.error[data-v-2a67d988]{font-size:13px;margin-top:8px;direction:rtl;text-align:right;font-weight:500}.error[data-v-2a67d988],.external-error[data-v-2a67d988]{color:#d32f2f;background-color:transparent!important}.external-error[data-v-2a67d988]{font-size:12px;display:block}", ""]);
// Exports
module.exports = exports;
